export default function Download() {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="card text-center">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Download File</h1>
          <p className="text-gray-600 mb-6">File download page</p>
          <button className="btn-primary">Download File</button>
        </div>
      </div>
    </div>
  )
} 